import ResetConfigurationButton from './ResetConfigurationButton'
import resetConfigurationButtonContainer from './resetConfigurationButtonContainer'

export default resetConfigurationButtonContainer(ResetConfigurationButton)
